module.exports = __webpack_public_path__ + "img/situazione-contabile.6118ad9b.jpg";